import EarlyAccessIcon from 'img/icons/offering_icons/earlyaccess_icon.svg';
import {
  BodyRowType,
  HeaderIconConfig,
  IconLabel,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';

const earlyAccessIconConfig: HeaderIconConfig = {
  backgroundColor: '#4394E5',
  color: '#000',
  iconTitle: 'Delivery format: Course',
  src: EarlyAccessIcon,
};

const earlyAccessConfig: OfferingTypeConfig = {
  actionButtons: ({ displayProgress, entry, hasProgress, catalogStore, t }) => {
    const link = catalogStore.getCatalogEntryLink(entry, { hasProgress });
    if (!link) {
      return {};
    }

    return {
      actionButtonA: {
        buttonLabel: displayProgress ? t('Continue') : t('View'),
        href: link.href,
        icon: IconType.Arrow,
        onClick: link.navigate,
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Icons],
  headerConfig: ({ t }) => ({
    iconB: earlyAccessIconConfig,
    title: t('Early access'),
  }),
  iconRowsLayout: () => [[IconLabel.Duration, IconLabel.Level]],
};

export default earlyAccessConfig;
